<template>
  <base-layout>
    <h1 slot="header">
      {{ `app.pages.users` | trans }}
    </h1>
    <v-app id="vuetify-app">
      <v-container fluid pl-0 pr-0 pt-0 pb-0>
        <v-layout row wrap align-content-start>
          <v-container fluid>
            <v-layout row justify-end>
              <v-flex xs2>
                <v-checkbox
                    v-model="with_patients"
                    class="ml-4"
                    :label="`app.download_newsletter_with_patients`|trans"
                    :color="`success`"
                ></v-checkbox>
              </v-flex>
              <v-flex xs2 pa-2>
                <v-menu
                    v-model="cal"
                    :close-on-content-click="true"
                    :nudge-right="40"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                        v-model="newsletter_date"
                        readonly
                        clearable
                        single-line
                        hide-details
                        solo
                        :label="trans('app.date')"
                        v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="newsletter_date" @input="cal = false" locale="pl-pl" first-day-of-week="1"></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex xs2 pa-2>
                <v-select solo v-model="newsletter_role" :items="roles"></v-select>
              </v-flex>
              <v-flex xs2 d-flex pa-2>
                <loading-button :loading="isLoading" :status="status" @click="downloadNewsletterUsers()"
                                :disabled="newsletter_date === null" style="height:48px;">
                  {{ 'app.download_newsletter' | trans }}
                </loading-button>
              </v-flex>
            </v-layout>
            <v-layout row wrap justify-space-between>
              <subscriptions-dialog
                  :dialog="showSubscriptions"
                  :user_id="user_id"
                  @closed="onSubscriptionsClose()"
              ></subscriptions-dialog>
              <subscription-form
                  method="POST"
                  :dialog="showAddSubscription"
                  :user_id="user_id"
                  @closed="onAddSubscriptionClose()"
              ></subscription-form>
              <v-flex>
                <user-manage-modal ref="userManageModal" @userUpdated="loadUsers"/>
                <user-import @imported="loadUsers"></user-import>
              </v-flex>
              <v-flex>
                <v-select
                    v-model="filters.role"
                    :items="rolesForSelect()"
                    :label="'app.pages.roles' | trans"
                    solo
                    clearable
                    class="pr-3"
                ></v-select>
              </v-flex>
              <v-flex>
                <v-text-field
                    v-model="filters.query"
                    append-icon="search"
                    :label="trans('app.search.search')"
                    single-line
                    hide-details
                    solo
                    clearable
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-container>
          <v-flex xs12>
            <resource-table ref="table" endpoint="/administrator/users" :headers="headers"
                            :filters="filters">
              <template #content="{item}">
                <tr>
                  <td>
                    {{ item.id }}
                  </td>
                  <td>
                    {{ item.name }}
                  </td>
                  <td>
                    {{ item.email }}
                  </td>
                  <td>
                    {{ item.patientsCount }}
                  </td>
                  <td>
                    <v-chip v-for="role in item.roles" :key="role">
                      {{ trans('page.roles.' + role) }}
                    </v-chip>
                  </td>
                  <td>
                    {{ item.lastLogin }}
                  </td>
                  <td class="justify-end layout px-0 pr-4">
                    <v-tooltip top>
                      <template #activator="{ on }">
                        <v-btn
                            v-on="on"
                            flat
                            icon
                            color="blue"
                            class="mr-0 ml-0"
                            @click="addSubscription(item)">
                          <v-icon small>library_add</v-icon>
                        </v-btn>
                      </template>
                      <span>{{ 'page.subscriptions.add_subscription' | trans }}</span>
                    </v-tooltip>
                    <v-tooltip top>
                      <template #activator="{ on }">
                        <v-btn
                            v-on="on"
                            flat
                            icon
                            color="red"
                            class="mr-0 ml-0"
                            @click="subscriptions(item)">
                          <v-icon small>calendar_today</v-icon>
                        </v-btn>
                      </template>
                      <span>{{ 'app.subscriptions.subscriptions' | trans }}</span>
                    </v-tooltip>

                    <v-tooltip top>
                      <template #activator="{ on }">
                        <v-btn
                            v-on="on"
                            flat
                            icon
                            color="blue"
                            class="mr-0 ml-0"
                            @click="actAs(item)">
                          <v-icon small>lock_open</v-icon>
                        </v-btn>
                      </template>
                      <span>{{ 'app.login_as_user' | trans }}</span>
                    </v-tooltip>

                    <v-tooltip top>
                      <template #activator="{ on }">
                        <v-btn
                            v-on="on"
                            flat
                            icon
                            color="green"
                            class="mr-0 ml-0"
                            @click="editItem(item)">
                          <v-icon small>edit</v-icon>
                        </v-btn>
                      </template>
                      <span>{{ 'app.edit' | trans }}</span>
                    </v-tooltip>
                  </td>
                </tr>
              </template>
            </resource-table>
          </v-flex>
        </v-layout>
      </v-container>
    </v-app>
  </base-layout>
</template>

<script>
import {trans} from '../../../app';
import {mapGetters} from 'vuex';
import {
  ADMINISTRATOR,
  DIETITIAN_EDUCATION,
  DIETITIAN_FREE,
  DIETITIAN_INACTIVE,
  DIETITIAN_PREMIUM,
  DIETITIAN_STANDARD,
  DIETITIAN_STUDENT,
  DIETITIAN_TEST, EMPLOYEE, PATIENT
} from "../../../utils/roles";

export default {

  data: () => ({
    items: [],
    model: null,
    user_id: null,
    showSubscriptions: false,
    showAddSubscription: false,
    cal: false,
    with_patients: false,
    newsletter_date: null,
    newsletter_role: DIETITIAN_PREMIUM,
    isLoading: false,
    status: '',
    filters: {
      query: null,
      role: null,
    },
    headers: [
      {
        text: trans('app.id'), align: 'left', value: 'id', sortable: true,
      },
      {
        text: trans('app.name'), align: 'left', value: 'name', sortable: true,
      },
      {
        text: trans('app.email'), align: 'left', value: 'email', sortable: true,
      },
      {
        text: trans('app.patients.patients'), align: 'left', value: 'patients', sortable: false,
      },
      {
        text: trans('app.role'), align: 'left', value: 'role', sortable: true,
      },
      {
        text: trans('app.last_login'), align: 'left', value: 'lastLogin', sortable: true,
      },
      {
        text: '', align: 'center', value: '', sortable: false,
      },
    ],
    pagination: {},
    errors: {},
  }),

  mounted() {
    this.$root.$on('stored', this.$refs.table.fetchData);
  },
  computed: {
    ...mapGetters(['hasPermission']),
    roles() {
      return [
        {value: DIETITIAN_PREMIUM, text: trans('page.roles.dietitian_premium')},
        {value: DIETITIAN_STANDARD, text: trans('page.roles.dietitian_standard')},
        {value: DIETITIAN_STUDENT, text: trans('page.roles.dietitian_student')},
        {value: DIETITIAN_TEST, text: trans('page.roles.dietitian_test')},
        {value: DIETITIAN_INACTIVE, text: trans('page.roles.dietitian_inactive')},
        {value: DIETITIAN_FREE, text: trans('page.roles.dietitian_free')},
      ];
    },
    allRoles() {
      return [
        {value: ADMINISTRATOR, text: trans('page.roles.administrator')},
        ...this.roles,
        {value: DIETITIAN_EDUCATION, text: trans('page.roles.dietitian_education')},
        {value: EMPLOYEE, text: trans('page.roles.employee')},
        {value: PATIENT, text: trans('page.roles.patient')},
      ];
    },
  },
  methods: {
    rolesForSelect() {
      return [{text: '', value: ''}, ...this.allRoles];
    },
    editItem(item) {
      const role = Array.isArray(item.roles) && item.roles.length > 0 ? item.roles[0] : null;
      this.$refs.userManageModal.open({
        id: item.id,
        name: item.name,
        email: item.email,
        roles: role,
      });
    },

    async actAs(user) {
      try {
        await axios.post(`/administrator/users/${user.id}/login`);
        window.location = '/';
      } catch (e) {
        console.error(e);
      }
    },

    subscriptions(item) {
      this.user_id = item.id;
      this.showSubscriptions = true;
    },

    onSubscriptionsClose() {
      this.user_id = null;
      this.showSubscriptions = false;
    },

    addSubscription(item) {
      this.user_id = item.id;
      this.showAddSubscription = true;
    },

    onAddSubscriptionClose() {
      this.user_id = null;
      this.showAddSubscription = false;
    },

    downloadNewsletterUsers() {
      this.isLoading = true;
      const date = this.newsletter_date;
      const role = this.newsletter_role;
      const with_patients = this.with_patients;

      axios.get(`/administrator/users/newsletter`, {
        params: {
          date: date,
          role: role,
          with_patients: with_patients,
        },
        headers: {
          'Accept': 'text/csv',
        },
        responseType: 'arraybuffer',
      }).then(({data}) => {
        const downloadUrl = window.URL.createObjectURL(new Blob([data]));
        const link = document.createElement('a');
        link.href = downloadUrl;
        link.setAttribute('download', `newsletter_${date}_${role}.csv`);
        document.body.appendChild(link);
        link.click();
        link.remove();
        this.status = true;
        this.isLoading = false;
      }).catch((error) => {
        this.isLoading = false;
        this.status = false;
        this.$toast(trans('app.no_newsletter_users'));
        this.sentryCaptureException(error);
      });

    },

    loadUsers() {
      this.$refs.table.fetchData();
    }
  },
};
</script>
